// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
function CustomCursor() {
  let e = (0, React.useRef)(null),
    t = (0, React.useRef)(null),
    i = (0, React.useRef)({
      x: 0,
      y: 0,
    }),
    n = (0, React.useRef)(false);
  return (
    (0, React.useEffect)(() => {
      if (window.matchMedia("(hover: none) and (pointer: coarse)").matches)
        return;
      let o = document.createElement("div");
      ((o.className = "cursor-ring"),
        (o.style.opacity = "0"),
        document.body.append(o),
        (e.current = o));
      let a = document.createElement("div");
      ((a.className = "cursor-dot"),
        (a.style.opacity = "0"),
        document.body.append(a),
        (t.current = a));
      let r = (e) => {
          ((i.current.x = e.clientX),
            (i.current.y = e.clientY),
            (a.style.left = `${e.clientX}px`),
            (a.style.top = `${e.clientY}px`),
            (o.style.left = `${e.clientX}px`),
            (o.style.top = `${e.clientY}px`),
            n.current ||
              ((n.current = true),
              (o.style.opacity = "1"),
              (a.style.opacity = "1")));
        },
        l = () => {
          ((o.style.opacity = "0"), (a.style.opacity = "0"));
        },
        s = () => {
          ((o.style.opacity = "1"), (a.style.opacity = "1"));
        };
      for (let e of (document.addEventListener("mousemove", r),
      document.addEventListener("mouseleave", l),
      document.addEventListener("mouseenter", s),
      document.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, p, span, li, a:not(button):not([class*="btn"])',
      )))
        (e.addEventListener("mouseenter", () => o.classList.add("cursor-text")),
          e.addEventListener("mouseleave", () =>
            o.classList.remove("cursor-text"),
          ));
      for (let e of document.querySelectorAll('button, [class*="btn"]'))
        (e.addEventListener("mouseenter", () =>
          o.classList.add("cursor-button"),
        ),
          e.addEventListener("mouseleave", () =>
            o.classList.remove("cursor-button"),
          ));
      return () => {
        (document.removeEventListener("mousemove", r),
          document.removeEventListener("mouseleave", l),
          document.removeEventListener("mouseenter", s),
          o.remove(),
          a.remove());
      };
    }, []),
    null
  );
}
export { CustomCursor };
